

















































































import { Component, Vue } from "vue-property-decorator";
import FlightClass from "@/store/entities/flight/flightClass";
import FlightSegment from "@/store/entities/flight/flightSegment";
import FlightSaleChannel from "@/store/entities/flight/flightSaleChannel";
import FlightPrice from "@/store/entities/flight/flightPrice";
@Component({})
export default class UpdateFlightPriceModal extends Vue {
  dialog: boolean = true;

  passport: Date = null;
  birthday: Date = null;
  flightClasses: FlightClass[] = [];
  flightSegments: FlightSegment[] = [];
  flightSaleChannels: FlightSaleChannel[] = [];
  flightPrice: FlightPrice = new FlightPrice();
  passengerTypeItems: any[] = [
    {
      name: "Adult",
      id: 1,
    },
    {
      name: "Child",
      id: 2,
    },
    {
      name: "Infant",
      id: 3,
    },
  ];
  created() {
    this.getFlightClasses();
    this.getFlightSegments();
    this.getFlightSaleChannels();
  }

  updatePrice(e) {
    e.preventDefault();
    this.$emit("flightPrice", this.flightPrice);
    this.dialog = false;
  }

  async getFlightClasses() {
    await this.$store.dispatch({
      type: "flightClass/getFlightClasses",
    });

    this.flightClasses = this.$store.state.flightClass.list;
  }

  async getFlightSegments() {
    await this.$store.dispatch({
      type: "flightSegment/getFlightSegments",
    });

    this.flightSegments = this.$store.state.flightSegment.list;
  }

  async getFlightSaleChannels() {
    await this.$store.dispatch({
      type: "flightSaleChannel/getFlightSaleChannels",
    });

    this.flightSaleChannels = this.$store.state.flightSaleChannel.list;
  }

  closeDialog() {
    this.$emit("closed");
  }
}
